module.exports = __webpack_public_path__ + "img/IEBNPSEC.695d3c93.svg";